var React = require('react');

function IconDashCode (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M390.3 592.5c-2.7 0-5.4-.5-8.1-1.4-168.8-60.6-174.6-63.8-176.6-64.9-7.8-4.3-13.2-11.5-14.8-20-2.5-13.6 5.4-24.3 7.9-27.2 2.6-3.1 6-5.5 9.8-6.9l173.2-65.6c12.4-4.7 26.2 1.6 30.9 13.9 4.7 12.4-1.6 26.2-13.9 30.9L271 499.7c37 13.5 89.7 32.5 127.5 46.1 12.5 4.5 19 18.2 14.5 30.7-3.6 9.9-12.8 16-22.7 16zM615.1 592.1c2.7 0 5.4-.5 8.1-1.4 168.8-60.6 174.6-63.8 176.6-64.9 7.8-4.3 13.2-11.5 14.8-20 2.5-13.6-5.4-24.3-7.9-27.2-2.6-3.1-6-5.5-9.8-6.9l-173.2-65.6c-12.4-4.7-26.2 1.6-30.9 13.9-4.7 12.4 1.6 26.2 13.9 30.9l127.8 48.4c-37 13.5-89.7 32.5-127.5 46.1-12.5 4.5-19 18.2-14.5 30.7 3.5 9.9 12.7 16 22.6 16zM454.3 676.6c-2.3 0-4.7-.3-7.1-1.1-12.7-3.9-19.8-17.4-15.8-30L526.7 337c3.9-12.7 17.4-19.8 30-15.8 12.7 3.9 19.8 17.4 15.8 30l-95.3 308.5c-3.1 10.3-12.6 16.9-22.9 16.9z"}));
}

IconDashCode.displayName = "IconDashCode";

IconDashCode.defaultProps = {"viewBox":"0 0 1000.6 1000.7"};

module.exports = IconDashCode;

IconDashCode.default = IconDashCode;
